import { render, staticRenderFns } from "./WidgetsCheckGroup.vue?vue&type=template&id=c5051bf8&scoped=true&"
import script from "./WidgetsCheckGroup.vue?vue&type=script&lang=js&"
export * from "./WidgetsCheckGroup.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsCheckGroup.vue?vue&type=style&index=0&id=c5051bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5051bf8",
  null
  
)

export default component.exports